import { render, staticRenderFns } from "./SalesNumberIndicator.vue?vue&type=template&id=2aaf4e5e&scoped=true"
import script from "./SalesNumberIndicator.vue?vue&type=script&lang=js"
export * from "./SalesNumberIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf4e5e",
  null
  
)

export default component.exports